import React from 'react';
import { ScheduleCellProps } from './types';

type Props = ScheduleCellProps & {
  getGuaranteedToRunLabel?: (offering: any) => React.ReactNode;
};

const GuaranteedToRunCell = ({ row, getGuaranteedToRunLabel }: Props) => {
  const offering = row?.original;

  if (getGuaranteedToRunLabel) {
    return <>{getGuaranteedToRunLabel(offering)}</>;
  }

  if (!offering?.status) {
    return null;
  }

  return <>{offering.status}</>;
};

export default GuaranteedToRunCell;
